import { render, staticRenderFns } from "./AnimationIssuesCard.vue?vue&type=template&id=6a79d3e9&"
import script from "./AnimationIssuesCard.vue?vue&type=script&lang=js&"
export * from "./AnimationIssuesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports